import type { Event, EventTimelineNote } from 'events/_types';

export type EventSearchEntry =
  | { kind: 'event'; event: Event; created: string }
  | {
      kind: 'note';
      event: Event;
      note: EventTimelineNote;
      created: string;
    };

export interface EventSearchGroup {
  event: Event;
  matchedEvent: boolean;
  notes: EventTimelineNote[];
  latestCreated: string;
}

export function getGroupKey(group: EventSearchGroup): string {
  return `event-${group.event.id}`;
}

export function groupEventSearchEntries(
  entries: EventSearchEntry[]
): EventSearchGroup[] {
  const groups = new Map<string, EventSearchGroup>();
  const order: string[] = [];

  entries.forEach((entry) => {
    const { id } = entry.event;
    let group = groups.get(id);
    if (!group) {
      group = {
        event: entry.event,
        matchedEvent: false,
        notes: [],
        latestCreated: entry.created,
      };
      groups.set(id, group);
      order.push(id);
    }
    if (entry.created > group.latestCreated) {
      group.latestCreated = entry.created;
    }
    if (entry.kind === 'event') {
      group.matchedEvent = true;
    } else {
      group.notes.push(entry.note);
    }
  });

  return order.map((id) => groups.get(id) as EventSearchGroup);
}
